import i18n from "i18n";

export const NoticeBoardsTableHeader = (customCaptions) => {
	return [
		{ id: 1, name: i18n.t("label.name"), width: "25vw" },
		{
			id: 2,
			name: i18n.t("label.description"),
			width: "25vw",
		},
		{ id: 3, name: customCaptions?.departmentPlural, width: "25vw" },
		{ id: 4, name: i18n.t("label.expires"), width: "25vw" },
	];
};
export const NoticeBoardsTableColumns = () => {
	return ["name", "description", "departments", "expiryDate"];
};
